import React from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertTriangle } from 'lucide-react';
export function Urgency() {
  return <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto text-center" data-id="element-300">
      <div className="inline-flex items-center gap-2 text-brand-red font-bold mb-6" data-id="element-301">
        <Clock className="w-5 h-5 animate-pulse" data-id="element-302" />
        <span data-id="element-303">PRECIO DE LANZAMIENTO — CIERRA EN:</span>
      </div>

      <div className="flex justify-center gap-4 mb-8" data-id="element-304">
        {[{
        value: '23',
        label: 'hs'
      }, {
        value: '25',
        label: 'min'
      }, {
        value: '21',
        label: 'seg'
      }].map((time, i) => <div key={i} className="flex flex-col items-center" data-id="element-305">
            <div className="bg-red-950 border border-red-900 text-white text-4xl md:text-5xl font-bold py-4 px-6 rounded-xl shadow-[0_0_15px_rgba(229,57,53,0.2)]" data-id="element-306">
              {time.value}
            </div>
            <span className="text-gray-400 text-sm mt-2 font-medium uppercase tracking-wider" data-id="element-307">
              {time.label}
            </span>
          </div>)}
      </div>

      <div className="flex items-center justify-center gap-2 text-gray-300 mb-8 bg-white/5 py-2 px-4 rounded-lg inline-flex" data-id="element-308">
        <AlertTriangle className="w-4 h-4 text-brand-gold" data-id="element-309" />
        <span data-id="element-310">
          Después sube $10.000 ARS. No vuelve al precio de lanzamiento.
        </span>
      </div>

      <div className="max-w-md mx-auto" data-id="element-311">
        <div className="flex justify-between text-sm mb-2" data-id="element-312">
          <span className="text-brand-red font-bold flex items-center gap-1" data-id="element-313">
            <span className="w-2 h-2 rounded-full bg-brand-red animate-pulse" data-id="element-314" />
            Cupos al precio de lanzamiento
          </span>
          <span className="text-white font-bold" data-id="element-315">68%</span>
        </div>
        <div className="h-4 bg-white/10 rounded-full overflow-hidden border border-white/5" data-id="element-316">
          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: '68%'
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="h-full bg-gradient-to-r from-brand-red to-red-400" data-id="element-317" />
        </div>
        <p className="text-xs text-gray-400 mt-2" data-id="element-318">
          68% de los cupos al precio de lanzamiento ya tomados. Quedan pocos
          disponibles.
        </p>
      </div>
    </section>;
}